import http from '../../shared/http.js';
import { withFlash } from '../../shared/flash.js';
import { confirmAction, hideLoading, notifyError, showLoading } from '../../shared/notify.js';

// Deliberately duplicated from config/env.js: this is a fail-fast convenience
// so an obviously wrong file never leaves the browser. The server's limits in
// middleware/upload.js stay the authority.
const MAX_BYTES = 5 * 1024 * 1024;
const ALLOWED_TYPES = ['image/jpeg', 'image/png', 'image/webp'];

export function initAvatar() {
  const form = document.getElementById('avatar-form');
  if (!form) return;

  const input = document.getElementById('avatar-input');
  const image = document.getElementById('avatar-preview');
  const monogram = document.getElementById('avatar-initials');
  const submit = document.getElementById('avatar-submit');
  const remove = document.getElementById('avatar-remove');

  // What the server currently has, so a rejected pick can be rolled back.
  const savedSrc = image.getAttribute('src');

  const showImage = (src) => {
    image.src = src;
    image.classList.remove('hidden');
    monogram.classList.add('hidden');
  };

  const restore = () => {
    input.value = '';
    if (savedSrc) {
      showImage(savedSrc);
      return;
    }
    image.removeAttribute('src');
    image.classList.add('hidden');
    monogram.classList.remove('hidden');
  };

  const reject = (message) => {
    notifyError(message);
    restore();
  };

  input.addEventListener('change', () => {
    const file = input.files[0];
    if (!file) return;
    if (!ALLOWED_TYPES.includes(file.type)) {
      reject('Nur JPG-, PNG- oder WebP-Bilder sind erlaubt.');
      return;
    }
    if (file.size > MAX_BYTES) {
      reject('Das Bild ist zu gross. Erlaubt sind maximal 5 MB.');
      return;
    }

    // FileReader rather than URL.createObjectURL: the Content-Security-Policy
    // allows img-src 'self' data:, and a blob: URL matches neither.
    const reader = new window.FileReader();
    reader.addEventListener('load', () => showImage(reader.result));
    reader.addEventListener('error', () => reject('Die Datei konnte nicht gelesen werden.'));
    reader.readAsDataURL(file);
  });

  form.addEventListener('submit', async (event) => {
    event.preventDefault();

    const file = input.files[0];
    if (!file) {
      notifyError('Bitte wählen Sie ein Bild aus.');
      return;
    }

    const body = new FormData();
    body.append('avatar', file);

    submit.disabled = true;
    showLoading('Profilbild wird gespeichert …');

    try {
      // No Content-Type header on purpose: axios recognises a FormData body and
      // leaves it to the browser, which is the only thing that can generate the
      // multipart boundary. Setting the header by hand breaks the upload.
      await http.post('/users/me/avatar', body);
      // A full reload rather than swapping the src in place: the navbar avatar
      // is rendered server-side, so an in-place swap would leave the navbar
      // showing the old picture until the next navigation.
      window.location.href = withFlash('/settings', 'profilbild-gespeichert');
    } catch (err) {
      hideLoading();
      submit.disabled = false;
      notifyError(
        err.response?.data?.message || 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.'
      );
    }
  });

  remove.addEventListener('click', async () => {
    const confirmed = await confirmAction({
      title: 'Profilbild entfernen',
      message: 'Möchten Sie Ihr Profilbild wirklich entfernen?',
      okText: 'Entfernen'
    });
    if (!confirmed) return;

    showLoading('Profilbild wird entfernt …');

    try {
      await http.delete('/users/me/avatar');
      window.location.href = withFlash('/settings', 'profilbild-entfernt');
    } catch (err) {
      hideLoading();
      notifyError(
        err.response?.data?.message || 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.'
      );
    }
  });
}
